import global from "../config/global";

export default class FBQ{
  static reg_suc(){
    fbq('track','CompleteRegistration')
  }

  static purchase_suc(params){
    fbq('track','Purchase',params)
  }

  static user_action(){
    fbq('track','Lead');
  }

  static custom_events(events){
    fbq('track',events);
  }
}



// WEBPACK FOOTER //
// ./src/utils/fbqutils.js